export default function(baseFilter = '') {
  const params = baseFilter.split(',')
  let hierarchyId

  params.forEach(item => {
    if (item.includes('organizationHierarchyLevel.id=')) {
      hierarchyId = item.split('=')[1]
    }
  })

  return hierarchyId
}
